import { NextResponse } from 'next/server';
import type { ApiErrorResponse } from '../interfaces/ApiErrorResponse';

/**
 * @group Functions
 * @summary <blockquote>Handles authentication errors and returns a standardized error response.</blockquote>
 * @param message - Custom authentication error message
 * @returns A NextResponse with standardized error structure
 * @example
 * ```typescript
 * if (!user.isAuthenticated) {
 *   return handleAuthError('Invalid credentials');
 * }
 * ```
 */
export function handleAuthError(message: string = 'Unauthorized'): NextResponse<ApiErrorResponse> {
  return NextResponse.json({
    error: 'Authentication error',
    details: message
  }, { status: 401 });
} 